// src/theme.js
import { defaultTheme } from '@aws-amplify/ui-react';

export const customTheme = {
  ...defaultTheme,
  name: 'my-custom-theme',
  tokens: {
    ...defaultTheme.tokens,
    components: {
      ...defaultTheme.tokens.components,

      /* 1) Center & enlarge the Authenticator card */
      authenticator: {
        container: {
          margin:      { value: 'auto' },         // center
          maxWidth:    { value: '420px' },         // bump size
          minHeight:   { value: '700px' },         // ensure enough height
          padding:     { value: '{space.xl}' },
          borderRadius:{ value: '12px' },
          backgroundColor: { value: '{colors.background.primary}' },
        },
        header: {
          display:     { value: 'none' },          // hide default title
        },
      },

      /* 2) Ensure primary buttons match your brand */
      button: {
        primary: {
          backgroundColor: { value: '{colors.brand.primary}' },
          color:           { value: '{colors.white}' },
        },
      },
    },
    colors: {
      ...defaultTheme.tokens.colors,
      background: {
        primary: { value: 'white' },
      },
      brand: {
        primary: { value: '#1890ff' },
      },
    },
  },
};
